import { Menu, type MenuSelectGroupProps, Text } from "@overmap-ai/blocks"
import type { AssetTypeStatus, Stored } from "@overmap-ai/common"
import { memo } from "react"

import { AssetTypeStatusIcon } from "../Icons/AssetTypeStatusIcon"
import { SelectItemTemplate } from "../MenuGroups/constants"

export type AssetTypeStatusSelectGroupProps = MenuSelectGroupProps<Stored<AssetTypeStatus>> & {
	assetTypeStatuses: Stored<AssetTypeStatus>[]
}

export const AssetTypeStatusSelectGroup = memo<AssetTypeStatusSelectGroupProps>((props) => {
	const { ref, assetTypeStatuses, ...rest } = props

	return (
		<Menu.SelectGroup<Stored<AssetTypeStatus>> ref={ref} {...rest}>
			{assetTypeStatuses.map((assetTypeStatus) => (
				<SelectItemTemplate<Stored<AssetTypeStatus>> key={assetTypeStatus.uuid} value={assetTypeStatus}>
					<AssetTypeStatusIcon assetTypeStatusId={assetTypeStatus.uuid} />
					<Text className="truncate">{assetTypeStatus.name}</Text>
				</SelectItemTemplate>
			))}
		</Menu.SelectGroup>
	)
})
AssetTypeStatusSelectGroup.displayName = "AssetTypeStatusSelectGroup"
